<template>
  <a-modal title="订单详情" :width="900" :visible="visible" :confirmLoading="confirmLoading" :footer="false" @cancel="handleCancel" v-if="hackReset">
    <div class="viewDetial-tiem">
      <div class="viewDetial-title">患者信息</div>
      <a-row style="height:30px">
        <a-col :span="12">
          <label style="padding-left:15px">就诊人：{{ this.userDate.patientName }} / {{ this.userDate.sex == 1?'男':'女' }} / {{ this.userDate.age + '岁'}} </label>
        </a-col>

        <a-col :span="12">
          <label>身份证号：{{ this.userDate.cardno == '' || this.userDate.cardno == null || this.userDate.cardno == undefined ? '' :
            this.userDate.cardno.replace(/^(\d{2})\d+(\d{2})$/, "$1************$2") }}
          </label>
        </a-col>
      </a-row>

      <a-row style="height:30px">
        <a-col :span="12">
          <label style="padding-left:15px">手机号：{{ this.userDate.mobile }}</label>
        </a-col>
        <!-- <a-col :span="12">
          <label style="padding-left:28px">地址：{{ this.userDate.address  }}</label>
        </a-col> -->
      </a-row>
    </div>

    <div class="viewDetial-tiem">
      <div class="viewDetial-title">预约信息</div>
      <a-row style="height:30px">
        <!-- <a-col :span="12">
          <label style="padding-left:15px">收货人：{{ this.userDate.contactName }}</label>
        </a-col> -->
        <a-col :span="12">
          <label>上门地址：{{ this.userDate.shippingAddress }}</label>
        </a-col>
      </a-row>

      <a-row style="height:30px">
        <a-col :span="12">
          <label>预约项目：{{ this.userDate.itemName }}</label>
        </a-col>

        <a-col :span="12">
          <label>预约状态：
            <a>
              {{ this.userDate.status == 0 ? '待支付' : (this.userDate.status == 1 && this.userDate.nurse_status != 4 ) ? '已预约' : this.userDate.status == 2 ? '已完成' :
              this.userDate.status == 3 ?'已取消' : this.userDate.status == 4 ?'已上门' : (this.userDate.status == 1 && this.userDate.nurse_status == 4 ) ? '已预约,已接单': '' }}
            </a>
          </label>
        </a-col>
      </a-row>

      <a-row style="height:30px">
        <a-col :span="12">
          <label>
            护理人员：{{ this.userDate.nureName + ' / ' + (this.userDate.level == 1 ? '初级' : this.userDate.level == 2 ? '中级' : this.userDate.level == 3 ? '高级' : '' )}}
          </label>
        </a-col>

        <a-col :span="12">
          <label>支付金额：
            <span style="color:red" v-show="this.userDate.totalPrice">
              {{ (this.userDate.totalPrice  / 100).toFixed(2) }} ( {{ '护理费' + this.userDate.nurseCost / 100 + '元，上门费' + this.userDate.doorCost / 100 + '元，耗材'
              + this.userDate.consumableCost / 100 + '元，医疗服务费' + this.userDate.medicalServiceFee / 100 + '元'}})
            </span>
          </label>
        </a-col>
      </a-row>

      <a-row style="height:30px">
        <a-col :span="12">
          <label style="padding-left:28px">科室：{{ this.userDate.deptName }}</label>
        </a-col>
        <a-col :span="12">
          <label>创建时间：{{ this.userDate.createTime }}</label>
        </a-col>
      </a-row>

      <a-row style="height:30px">
        <a-col :span="12">
          <label style="padding-left:15px">耗材包：{{ this.userDate.consumable == 0 ? '无' : this.userDate.consumable == 1 ?
            '普通' : this.userDate.consumable == 2 ?'高级' : '' }}
          </label>
        </a-col>
        <a-col :span="12">
          <label>支付时间：{{ this.userDate.tradeTime }}</label>
        </a-col>
      </a-row>
    </div>

    <div class="viewDetial-tiem">
      <div class="viewDetial-title">上门信息</div>
      <a-row style="height:30px">
        <a-col :span="12">
          <label>接诊护士：{{ this.userDate.nureName + ' / ' + this.userDate.deptName }}</label>
        </a-col>
        <a-col :span="12">
          <label>上门时间：{{ this.userDate.doorTime }}</label>
        </a-col>
      </a-row>
    </div>

    <div class="viewDetial-tiem">
      <div class="viewDetial-title">护理过程记录</div>
      <a-row>
        <a-col :span="24" style="height:30px">
          <label>完成时间：{{ this.userDate.finishTime }}</label>
        </a-col>
        <a-col :span="24">
          <label>护理过程：{{ this.userDate.nurseProcess }} </label>
        </a-col>
      </a-row>
    </div>
  </a-modal>
</template>

<script>
  import {nursingDetial} from '@/api/modular/interhospital/nursing/nursingMange'

  export default {
    data() {
      return {
        labelCol: {xs: {span: 24}, sm: {span: 5}},
        wrapperCol: {xs: {span: 24}, sm: {span: 15}},
        ctstampDateString: '',
        birthdayDateString: '',
        visible: false,
        confirmLoading: false,
        form: this.$form.createForm(this),
        parameter: {},
        userDate: '',
        hackReset: true,
        deptList: [],
      }
    },

    methods: {
      // 初始化方法
      add(record) {
        this.visible = true;
        this.parameter.id = record.id;

        nursingDetial(this.parameter).then(res => {
          console.log(res)
          this.userDate = res.data;
          console.log(this.userDate)
        });
      },

      onChangectstamp(date, dateString) {
        this.ctstampDateString = dateString
      },

      onChangebirthday(date, dateString) {
        this.birthdayDateString = dateString
      },

      handleCancel() {
        this.visible = false;
        this.hackReset = false;
        this.$nextTick(() => {
          this.hackReset = true;
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .viewDetial-tiem {
    margin-bottom: 10px;
  }

  .viewDetial-title {
    height: 40px;
    line-height: 40px;
    font-family: "PingFang SC ", "PingFang SC", sans-serif;
    font-weight: 600;
    font-style: normal;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.847);
    margin-bottom: 20px;

    .viewDetial-title-notes {
      font-weight: 400;
      font-size: 13px;
      color: rgba(127, 127, 127, 0.847058823529412);
      margin-left: 15px;
    }
  }
</style>
